export const defaultStickyProps = {
	height: 180,
	width: 240,
	minHeight: 80,
	minWidth: 150,
	id: '0',
	editMode: false,
	readOnly: false,
	backgroundColor: 1,
};
